import ACTION_TYPE from '../ACTION_TYPE';

export const dispatchActivityEdit = activityId => dispatch => {
  dispatch({
    type: ACTION_TYPE.SET_ACTIVITY_ID,
    activityId
  });
};
